import { ConditionType, type IConditionDto, ConditionBase, ConditionState, type IConditionLabelOptions, type IVehicle, ConfigurationType } from "..";
import type { IServiceSchedule } from "../ServiceSchedule";

export class ServiceCondition extends ConditionBase
{

    constructor( vehicle: IVehicle, model: IConditionDto )
    {
        super( vehicle, model, ConditionType.Service, ConfigurationType.Monthly );
        this.icon = 'dashboard:service';
        this.ordinal = 2;
        this.initialise();
    }

    /**
     * Sets the service schedule and adjusts the state of the condition.
     * @param serviceSchedule 
     */
    setServiceSchedule( serviceSchedule: IServiceSchedule )
    {
        // If the service schedule isn't configured with a next interval, make the condition 'unset'
        if( serviceSchedule.nextInterval == null )
        {
            this.state = ConditionState.Incomplete;
            this.initialise();
        }
    }

    /**
     * Gets the labels for the condition.  The labels are used to provide meaningful
     * user interface statements/prompts that are specific to the condition
     */
    override getLabels(): IConditionLabelOptions 
    {
        return {
            name: "Service",
            shortName: 'Service',
            longName: "Service",
            intervalJustCompletedMessage: "Service was just completed",
            cta: "Let's get you booked in",
            maintenanceVerb: 'Service',
            protectedByLabel: 'Your car is protected by'
        };
    }

    /**
     * Gets the description for the interval update for this condition
     * @returns 
     */
    protected override getIntervalDescription()
    {
        if( this.averageOdometerInterval == 0 ) return 'n/a';
        return `To maintain it's warranty and keep it's market value, a car needs to be serviced ${ super.getIntervalDescription( this.vehicle, this ) }`;
    }

    /**
     * Gets the action message for the service note
     */
    override getActionMessage() 
    {
        switch( this.state )
        {
            case ConditionState.Due: return 'Based on your service schedule, your service is due and you should book an appointment as soon as possible';
            case ConditionState.Overdue: return 'Based on your service schedule, your service is overdue and you should book an appointment as soon as possible';
            case ConditionState.Critical: return 'If you have an engine or mechanical issue, you should book an appointment as soon as possible';
            default: return '';
        }
    }

}
